module.exports = __webpack_public_path__ + "assets/img/fb8467143b148d696e127f0bff88d46b.svg";